import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { RingFencedFundsMessageUpdated } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/ringFencedFundsWrapper/RingFencedFundsWrapperUpdated';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { RingFencedFundsMessage } from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/depositSignupPage/RingFencedFundsMessage';

interface RingFencedFundsWrapperType {
    isMoreShown: boolean;
    toggleShowMore: () => void;
    isSignup: boolean;
}

export const RingFencedFundsWrapper = observer(
    'RingFencedFundsWrapper',
    (props: RingFencedFundsWrapperType): JSX.Element | null => {
        const common = useCommon();
        const config = ConfigComponents.get(common).config;
        const { isMoreShown, toggleShowMore, isSignup } = props;

        if (config.isSaferGambling.available) {
            return <RingFencedFundsMessageUpdated isSignup={isSignup} />;
        } else {
            return (
                <RingFencedFundsMessage
                    isMoreShown={isMoreShown}
                    toggleShowMore={toggleShowMore}
                    isSignup={isSignup}
                />
            );
        }
    }
);
